
  <div class="wrap person-wrap">
    <img
      class="wrap-title"
      src="@/assets/img/person/person-title.png"
      alt=""
      srcset=""
    />
    <h2 class="person-title">请填写个人信息</h2>
    <div class="ques-content">
      <ul
        class="ques-item"
        v-for="(item, index) in personList"
        :key="item.title + index"
      >
        <!-- 单项填空题 -->
        <Info-Input
          v-if="
            item.questionType == 4 ||
            item.questionType == 11 ||
            item.questionType == 16 ||
            item.questionType == 21 ||
            item.questionType == 25
          "
          :quesIndex="index"
          :showAnswerRequired="item.isRequired"
          :data="item"
          @inputChange="handleRadioSelect"
        />
        <!-- 多项填空题 -->
        <ManyInput
          v-else-if="item.questionType === 5"
          @inputChange="hanldeManyInput"
          :quesIndex="index"
          :showAnswerRequired="item.isRequired"
          :info="item"
        />
        <!-- 城市选择 -->
        <City-Select
          v-else-if="item.questionType == 9 || item.questionType == 10"
          :data="item"
          :quesIndex="index"
          :showAnswerRequired="item.isRequired"
          @selectCity="handleSelectCity"
        />
        <!-- 下拉框 -->
        <Drop-Down-Box
          v-else-if="item.questionType === 2"
          :showAnswerRequired="item.isRequired"
          :quesIndex="index"
          :data="item"
        />
        <!-- 级联题 -->
        <Cascader
          v-else-if="item.questionType === 20 || item.questionType === 100"
          :data="item"
          :showAnswerRequired="item.isRequired"
          :quesIndex="index"
          @cascaderChange="handleRadioSelect"
        />
        <!-- 单选择题 -->
        <Single-Choice
          v-else
          @radioSelect="handleRadioSelect"
          :quesIndex="index"
          :showAnswerRequired="item.isRequired"
          :data="item"
        />
      </ul>
      <p class="person-tips">注：个人信息请如实填写</p>
      <Button @click="handleSubmitPersonInfo" class="btn">提交并下一步</Button>
    </div>
  </div>
  <div @click="$emit('close')" class="mask"></div>
